var moment = require('moment');

function Module() {
	'use strict';
	var self = this;

	//	input elems can be masked using the 'pnl-mask-_____' attributes
	self.masks = {
		//	EXAMPLE: <input type="number" pnl-mask-number min="1" max="500"> will limit text input to a 3-digit number less than 500
		pnlMaskNumber: function pnlMaskNumber() {
			return {
				restrict: 'A',
				link: function pnlMaskNumberLink(scope, elem, attrs) {
					elem.bind('input', function bindInput() {
						var newValue = this.value;
						newValue = Number(newValue.replace(/\D/g, ''));

						if (newValue && attrs.min && newValue < Number(attrs.min)) {
							newValue = Number(attrs.min);
						}

						if (newValue && attrs.max && newValue > Number(attrs.max)) {
							newValue = Number(attrs.max);
						}

						this.value = newValue;
						_.set(scope, attrs.ngModel, newValue);
					});
				}
			};
		},
		//	EXAMPLE: <input type="text" pnl-mask-uppercase> will make all text uppercase
		pnlMaskUppercase: function pnlMaskUppercase() {
			return {
				restrict: 'A',
				link: function pnlMaskUppercaseLink(scope, elem, attrs) {
					elem.bind('keypress input blur', function bindInput(e) {
						var originalValue = this.value;
						var newValue = this.value;
						newValue = newValue.toUpperCase();

						var originalSelectionStart = e.currentTarget.selectionStart;

						this.value = newValue;

						if (originalSelectionStart !== originalValue.length) {
							e.currentTarget.selectionStart = originalSelectionStart;
							e.currentTarget.selectionEnd = originalSelectionStart;
						}

						_.set(scope, attrs.ngModel, newValue);
					});
					elem.addClass('uppercase');	//	make it display uppercase in addition to changing text
				}
			};
		},
		//	EXAMPLE: <input type="number" pnl-mask-float will only allow a float input value (e.g. "-2.15")
		pnlMaskFloat: function pnlMaskFloat() {
			return {
				restrict: 'A',
				link: function pnlMaskFloatLink(scope, elem, attrs) {
					elem.bind('input', function bindInput() {
						var newValue = this.value;
						newValue = newValue.replace(/[^0-9\.\-]/g, '');

						if (newValue && attrs.min && newValue < Number(attrs.min)) {
							newValue = attrs.min;
						}

						if (newValue && attrs.max && newValue > Number(attrs.max)) {
							newValue = attrs.max;
						}

						this.value = newValue;
						_.set(scope, attrs.ngModel, newValue);
					});
				}
			};
		},
		//	EXAMPLE: <input type="number" pnl-mask-date will only allow a date input value (e.g. "3-15-2015")
		pnlMaskDate: function pnlMaskDate() {
			return {
				restrict: 'A',
				link: function pnlMaskDateLink(scope, elem, attrs) {
					function formatAmericanDate(value) {  //  MM-DD-YYYY
						value = value
							.replace(/\//g, '-')	//	swap out slashes for dashes
							.replace(/^([2-9])$/, '0$1-')	//	leading 0 for months
							.replace(/^1\-$/, '01-')	//	leading zero after slash is pressed
							.replace(/^(\d{2}\-)([4-9])$/, '$1-0$2')	//	leading zero on days starting with 4-9
							.replace(/^(02\-)3/, '$103')	//	Feb only add lead zero on days with 3
							.replace(/^(\d{2})\-(\d{1})\-$/, '$1-0$2')	//	leading zero on days if slash is pressed
							.replace(/^(\d{2})\-(\d{1})\-(\d{4})$/, '$1-0$2-$3')	//	if the year is already present, preserve it
							.replace(/^(\d{1})\-(\d{2})\-(\d{4})$/, '0$1-$2-$3')	//	if the day and year are already present, preserve them
							.replace(/\D/g, '')	//	remove all slashes (leaving a 4-digit number)
							.replace(/^(\d{2})/, '$1-')	//	add in first slash after first 2-digits (month)
							.replace(/^(\d{2}\-\d{2})/, '$1-')	//	add in second slash after next 2-digits (day)
							.replace(/^(\d{2}\-\d{2}\-\d{4}).+/, '$1');	//	remove anything after 4 digit year

						if (!value.match(/^(0[1-9]|1[0-2]).*$/)) {	//	eliminate months 13 and above
							value = value.replace(/^\d\d.*/, '');
						}

						if (!value.match(/^\d{2}\-\d{2}\-(1\d*|2\d*)$/)) {
							value = value.replace(/^(\d{2}\-\d{2}\-).*/, '$1');
						}

						if (!value.match(/^\d{2}\-(0[1-9]|[1-2][0-9]|3[0-1]).*$/)) {	//	eliminate any days of month greater than 31 (e.g. 5/32)
							value = value.replace(/^(\d{2}\-)\d\d.*/, '$1');
						}

						if (value.match(/^02\-3.*$/) || value.match(/^0[469]\-31.*$/) || value.match(/^11\-31.*$/)) {	//	eliminate 2/30, 4/31, 11/31, etc.
							value = value.replace(/^(\d{2}\-)\d\d.*/, '$1');
						}

						if (value.slice(0, 5) === '02-29' && value.length === 10 && value.slice(-4) % 4 !== 0) {	//	eliminate Feb 29th on non-leap-years
							value = value.replace(/^02\-29/, '02-28');
						}

						return value || '';
					}

					function formatAustralianDate(value) {  //  DD-MM-YYYY
						value = value
							.replace(/\//g, '-')	//	swap out slashes for dashes
							.replace(/^([4-9])$/, '0$1-')	//	leading zero on days starting with 4-9
							.replace(/^(\d{1})\-$/, '0$1-')	//	leading zero on days if slash is pressed
							.replace(/^(\d{2}\-)([2-9])$/, '$1-0$2')	//	leading 0 for months
							.replace(/^(\d{2}\-)1\-$/, '$1-01-')	//	leading zero after slash is pressed
							.replace(/^(\d{2})\-(\d{1})\-(\d{4})$/, '$1-0$2-$3')	//	if the year is already present, preserve it (used for pasting dates)
							.replace(/^(\d{1})\-(\d{2})\-(\d{4})$/, '0$1-$2-$3')	//	if the day and year are already present, preserve them (used for pasting dates)
							.replace(/\D/g, '')	//	remove all slashes (leaving a 4-digit number)
							.replace(/^(\d{2})/, '$1-')	//	add in first slash after first 2-digits (day)
							.replace(/^(\d{2}\-\d{2})/, '$1-')	//	add in second slash after next 2-digits (month)
							.replace(/^(\d{2}\-\d{2}\-\d{4}).+/, '$1');	//	remove anything after 4 digit year

						if (!value.match(/^(0[1-9]|[1-2][0-9]|3[0-1]).*$/)) {	//	eliminate any days of month greater than 31 (e.g. 32)
							value = value.replace(/^\d\d.*/, '');
						}

						if (!value.match(/^\d{2}\-(0[1-9]|1[0-2]).*$/)) {	//	eliminate months 13 and above
							value = value.replace(/^(\d{2}\-)\d\d.*/, '$1');
						}

						if (!value.match(/^\d{2}\-\d{2}\-(1\d*|2\d*)$/)) { // Only accept years beginning with a one or a two
							value = value.replace(/^(\d{2}\-\d{2}\-).*/, '$1');
						}

						if (value.match(/^3.*\-02$/) || value.match(/^31\-0[469].*$/) || value.match(/^31\-11.*$/)) {	//	eliminate 30/2, 31/4, 31/11, etc.
							value = '';
						}

						if (value.slice(0, 5) === '29-02' && value.length === 10 && value.slice(-4) % 4 !== 0) {	//	eliminate Feb 29th on non-leap-years
							value = value.replace(/^29\-02/, '28-02');
						}

						return value || '';
					}

					elem.bind('keyup blur', function bindKeyupOrBlur(e) {
						//  as long as the key being pressed is not backspace (8), tab (9), delete (46), shift (16), end (35), home (36), or any arrow keys (37-40), mask it...
						if (e.type === 'blur' || !_.includes([8, 9, 46, 16, 35, 36, 37, 38, 39, 40], e.keyCode)) {
							var originalValue = this.value;
							var newValue = this.value;
							newValue = (_.isEmpty(attrs.pnlMaskDate) || attrs.pnlMaskDate === 'USA') ? formatAmericanDate(newValue) : formatAustralianDate(newValue);

							if (e.type === 'blur' && !moment(newValue, (_.isEmpty(attrs.pnlMaskDate) || attrs.pnlMaskDate === 'USA') ? 'MM-DD-YYYY' : 'DD-MM-YYYY').isValid()) {
								newValue = '';
							}

							var originalSelectionStart = e.currentTarget.selectionStart;

							this.value = newValue;

							if (originalSelectionStart !== originalValue.length) {
								e.currentTarget.selectionStart = originalSelectionStart;
								e.currentTarget.selectionEnd = originalSelectionStart;
							}

							_.set(scope, attrs.ngModel, newValue);
						}
					});
				}
			};
		},
		//	EXAMPLE: <input type="text" pnl-mask-phone> will only allow a phone input value (e.g. "(987)654-3210")
		//	EXAMPLE: <input type="text" pnl-mask-phone="aus"> will only allow a phone input value (e.g. "(98) 6544 3210")
		pnlMaskPhone: function pnlMaskPhone() {
			return {
				restrict: 'A',
				link: function pnlMaskPhoneLink(scope, elem, attrs) {
					elem.bind('keyup blur', function maskPhoneNumber(e) {
						var originalValue = this.value;
						var newValue = this.value;

						//  as long as the key being pressed is not backspace (8), tab (9), delete (46), shift (16), or any arrow keys (37-40), mask it...
						if (e.type === 'blur' || !_.includes([8, 9, 46, 16, 37, 38, 39, 40], e.keyCode)) {
							if (attrs.pnlMaskPhone.toLowerCase() === 'aus') {	//	Australian!
								newValue = newValue
									.replace(/\D/g, '');

								if (_.includes(['04', '4'], newValue.slice(0, 2))) { // Mobile phone numbers
									newValue = newValue
										.replace(/^([4])/, '04')
										.replace(/^(\d{4})/, '$1 ')
										.replace(/^(\d{4} \d{3})/, '$1 ')
										.replace(/^(\d{4} \d{3} \d{3}).+/, '$1');
								} else { // Landline phone numbers
									newValue = newValue
										.replace(/^/, '(')
										.replace(/^\(([1-9])/, '(0$1')
										.replace(/^\(0[^23478]/, '(0')
										.replace(/^(\(\d{2})/, '$1) ')
										.replace(/^(\(\d{2}\) \d{4})/, '$1 ')
										.replace(/^(\(\d{2}\) \d{4} \d{4}).+/, '$1');
								}
							} else {	//	USA! (default)
								newValue = newValue
									.replace(/\D/g, '')
									.replace(/^(0|1)+/, '')
									.replace(/^/, '(')
									.replace(/^(\(\d{3})/, '$1) ')
									.replace(/^(\(\d{3}\) )(0|1)+/, '$1')
									.replace(/^(\(\d{3}\) \d{3})/, '$1-')
									.replace(/^(\(\d{3}\) \d{3}-\d{4}).+/, '$1');
							}

							if (newValue.length === 1 && e.type === 'blur') {
								newValue = '';
							}

							var originalSelectionStart = e.currentTarget.selectionStart;

							this.value = newValue;

							if (originalSelectionStart !== originalValue.length) {
								e.currentTarget.selectionStart = originalSelectionStart;
								e.currentTarget.selectionEnd = originalSelectionStart;
							}

							_.set(scope, attrs.ngModel, newValue);
						}
					});
				}
			};
		},
		//	EXAMPLE: <input type="text" pnl-mask-email> //	accepts (email@example.com)
		//  this is intentionally VERY WEAK masking to guarantee acceptance of all valid email addresses)
		pnlMaskEmail: function pnlMaskEmail() {
			return {
				restrict: 'A',
				link: function pnlMaskEmailLink(scope, elem, attrs) {
					elem.bind('input', function bindInput() {
						var newValue = this.value
							.replace(/\s/g, '')
							.replace(/^([^@]*@[^@]*)@.*/, '$1');

						this.value = newValue;
					});
				}
			};
		},
		//	EXAMPLE: <input type="text" pnl-mask-post-code="USA"> //	accepts (99999)
		pnlMaskPostCode: function pnlMaskPostCode() {
			return {
				restrict: 'A',
				link: function pnlMaskPostCodeLink(scope, elem, attrs) {
					elem.bind('input', function bindInput(e) {
						var numChars = attrs.pnlMaskPostCode.toLowerCase() === 'aus' ? 4 : 5;
						var originalValue = this.value;
						var newValue = this.value
							.replace(/\D/g, '')
							.slice(0, numChars);

						var originalSelectionStart = e.currentTarget.selectionStart;

						this.value = newValue;

						if (originalSelectionStart !== originalValue.length) {
							e.currentTarget.selectionStart = originalSelectionStart;
							e.currentTarget.selectionEnd = originalSelectionStart;
						}

						_.set(scope, attrs.ngModel, newValue);
					});
				}
			};
		}
	};

	// used to apply all masking functions to the app
	self.apply = function apply(app) {
		app.directive('pnlMaskNumber', [self.masks.pnlMaskNumber]);
		app.directive('pnlMaskFloat', [self.masks.pnlMaskFloat]);
		app.directive('pnlMaskDate', [self.masks.pnlMaskDate]);
		app.directive('pnlMaskPhone', [self.masks.pnlMaskPhone]);
		app.directive('pnlMaskEmail', [self.masks.pnlMaskEmail]);
		app.directive('pnlMaskPostCode', [self.masks.pnlMaskPostCode]);
		app.directive('pnlMaskUppercase', [self.masks.pnlMaskUppercase]);
	};
}

module.exports = new Module();
